import React, { useRef } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import { FormGroup } from 'react-bootstrap';
import CommonAction from './CommonAction';

export function MultiSelectDropdown({
  placeholder,
  label,
  fromForm,
  duplicatingItem,
  gridIndex,
  pageIndex,
  editingInput,
  showDelete,
  deleteItem,
  value,
  onChange,
  options,
  supplierVisible,
  handleSupplierPermission,
  otherConfiguration,
  setParentGridZIndex,
  setOnElement,
  onElement,
  handleStaticGrid,
  isStatic,
  boldLabel,
  gridY,
}) {
  const multiSelectRef = useRef(null);

  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };

  const handleDropdownToggle = () => {
    // Check if the options dropdown is open by checking if the dropdown element exists in the DOM
    if (multiSelectRef.current) {
      const dropdownElement = multiSelectRef.current.querySelector('.dropdown-content');
      setParentGridZIndex(dropdownElement, gridIndex);
    }
  };
  return (
    <FormGroup className="flex-fill position-relative select-min-height">
      <div ref={multiSelectRef} className="custom-react-select-po">
        <p className={`mb-0 fs-custom-module field-lbl asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</p>
        {fromForm && onElement && (
          <CommonAction
            editingInput={editingInput}
            gridIndex={gridIndex}
            pageIndex={pageIndex}
            showDelete={showDelete}
            deleteItem={deleteItem}
            handleDuplicateItem={handleDuplicateItem}
            supplierVisible={supplierVisible}
            handleSupplierPermission={handleSupplierPermission}
            handleStaticGrid={handleStaticGrid}
            isStatic={isStatic}
          />
        )}
        <MultiSelect
          options={options}
          className={`custom-multiselect w-100 ${otherConfiguration?.bold && 'bold'} ${gridY > 30 && 'menu-dropdown-up'}`}
          value={value || []}
          labelledBy={placeholder}
          overrideStrings={{
            selectSomeItems: placeholder,
          }}
          onChange={(e) => onChange(e, label, gridIndex, pageIndex)}
          onMenuToggle={handleDropdownToggle}
        />
      </div>
    </FormGroup>
  );
}
export default MultiSelectDropdown;
